import { Flex, Grid, Heading, Text } from '@radix-ui/themes';
import { useAgent } from '@getdutchie/agent-react';
import { PICKUP_TILES } from './constants';
import { PickupTile } from './pickup-tile';

export function PickupPrompts() {
  const { sendMessage } = useAgent();

  return (
    <Flex direction="column" align="center" gap="6" py="8">
      <Flex direction="column" align="center" gap="2">
        <Heading size="7">How can I help today?</Heading>
        <Text size="3" color="gray">
          Get insights, run reports, and take action across your entire Dutchie Connect platform.
        </Text>
      </Flex>
      <Grid columns="3" gap="3" width="100%">
        {PICKUP_TILES.map((tile) => (
          <PickupTile key={tile.title} tile={tile} onClick={() => sendMessage(tile.prompt)} />
        ))}
      </Grid>
    </Flex>
  );
}
